import { AntBreadCrumbs } from "./styles";

export default AntBreadCrumbs;
